
import { Component, Mixins } from "vue-property-decorator";
import OfficeProfileMixin from "../../office-profiles.mixin";
import AuthMixin from "@/common/mixins/auth.mixin";
import { mapState } from "vuex";
import { OfficeDefaultRateFormDto, OfficeDefaultRateFormsDto } from "@/types/office.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
import { PositionDto } from "@/types/position.type";

@Component({
  computed: {
    ...mapState("OfficeProfile", ["rateForm", "positions"])
  }
})
export default class OfficeRatesEditComponent extends Mixins(OfficeProfileMixin, AuthMixin, ValidatedFormMixin) {
  rateForm!: OfficeDefaultRateFormsDto;
  positions!: PositionDto[];

  async mounted(): Promise<void> {
    await this.$store.dispatch("OfficeProfile/getPositions");

    this.positions.sort((a: PositionDto, b: PositionDto) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

    if (this.isEdit && this.selectedOffice) {
      this.rateForm.rates = this.selectedOffice.rates.map(rate => ({
        id: rate.id,
        positionId: rate.positionId,
        officeId: rate.officeId,
        amount: rate.amount,
        positionName: this.positions.find(position => position.id === rate.positionId)?.description
      } as OfficeDefaultRateFormDto));
    }
    else {
      this.positions.forEach(position => {
        this.rateForm.rates.push({
          id: null,
          positionId: position.id,
          officeId: 0,
          amount: 0,
          positionName: position.description
        } as OfficeDefaultRateFormDto);
      });    
    }

    this.$validator.reset();
  }

  async update(): Promise<void> {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.setLoading(true);

        await this.$store.dispatch("OfficeProfile/saveOfficeRates", this.rateForm);

        this.setLoading(false);
      }
    });
  }

  back(): void {
    this.$emit('update:activeTab', 2);
  }

  next(): void {
    this.$validator.validateAll().then((isValid: boolean) => {
      if (isValid) {
        this.$emit('update:activeTab', 4);
      }
    });
  }
}
